import { axiosGet } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const captchaInitUrl = '/api/captcha/init';

// Fetches a fresh captcha challenge: an opaque captchaId plus an SVG image to
// render. The answer itself never comes to the client — only the server can
// verify it (see helpers/captchaManager.js in api-cgc).
// Requires auth: this is only ever called from the logged-in booking page, and
// the backend now rejects it without a valid auth_token.
export const getCaptchaChallenge = async () => {
    const token = getAuthState('token');
    const response = await axiosGet(captchaInitUrl, { headers: { auth_token: `bearer ${token}` } });
    return { captchaId: response.captchaId, svg: response.svg };
}
